// Module
var code = "<div class=\"react-container react-zoom\"> <student-assignments-list-v2/> </div> ";
// Exports
module.exports = code;